module.exports = __webpack_public_path__ + "img/baby.bc964502.png";